import { render, staticRenderFns } from "./DatePicker.vue?vue&type=template&id=5a897ab3"
import script from "./DatePicker.vue?vue&type=script&lang=js"
export * from "./DatePicker.vue?vue&type=script&lang=js"
import style0 from "./DatePicker.vue?vue&type=style&index=0&id=5a897ab3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports